import { ListItemButton, ListItemIcon, ListItemText, Tooltip, Typography } from '@mui/material';
import { useNavigation } from '@/providers/navigation-provider';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { handleRedirect } from '@/utils/handle-redirect';
import { PRODUCT_LIFT_HOST } from '@/constants';
import { FeedbackRounded } from '@mui/icons-material';

export default function MainNavFeedback() {
    const { t } = useTranslation();
    const { mainNavOpen } = useNavigation();
    const navigate = useNavigate();

    return (
        <>
            <Tooltip
                title={t('str.help.feature.feedback')}
                arrow
                placement="right"
                disableHoverListener={mainNavOpen}
            >
                <ListItemButton
                    component={'div'} // Needed for the tooltip to work
                    dense={true}
                    sx={{ borderRadius: '99px' }}
                    {...(!mainNavOpen && { sx: { justifyContent: 'center' } })}
                    onClick={() => handleRedirect(PRODUCT_LIFT_HOST, navigate)}
                    data-productlift-link
                >
                    <ListItemIcon
                        sx={{
                            ...(!mainNavOpen && { minWidth: 0 }),
                        }}
                    >
                        <FeedbackRounded />
                    </ListItemIcon>
                    {mainNavOpen && (
                        <>
                            <ListItemText>
                                <Typography noWrap variant="body2">
                                    {t('str.help.feature.feedback')}
                                </Typography>
                            </ListItemText>
                        </>
                    )}
                </ListItemButton>
            </Tooltip>
        </>
    );
}
